import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import { getLinkTypeByKey } from 'functions/mediaLink'

import Button from 'components/Button'

import AgentLinksWrapper from 'agency/digital_renderer/components/AgentLinksWrapper'
import ReviewsWrapper from 'agency/digital_renderer/components/ReviewsWrapper'
import Reviews from './Reviews'
import styles from './styles.scss'

const Agent = (props) => {
  const {
    agent,
    agent: {
      agent_title, full_name, profile, default_image_large,
    },
  } = props

  return (
    <div className={styles.root}>
      <Fade>
        <div className={styles.agentHolder}>
          <span className={styles.agentImage} style={{ backgroundImage: `url(${default_image_large})` }} />
          <span className={styles.agentDetails}>
            <h2 style={{ margin: '15px 0' }}>{full_name}</h2>
            {agent_title && <h4 style={{ margin: '15px 0' }}>{agent_title}</h4>}

            <p className={styles.profile}>{profile}</p>

            <AgentLinksWrapper
              agent={agent}
              render={({ mediaLinks }) => (
                <div className={styles.links}>
                  {mediaLinks.map(mediaLink => (
                    <Button
                      key={mediaLink.id}
                      color="darkGrey"
                      ghost
                      href={mediaLink.url}
                      size="medium"
                      style={{ marginRight: 5 }}
                      target="_blank"
                      text={getLinkTypeByKey(mediaLink.link_type)}
                    />
                  ))}
                </div>
              )}
            />
          </span>
        </div>
      </Fade>

      <ReviewsWrapper agent={agent} render={params => <Reviews {...params} />} />
    </div>
  )
}

Agent.propTypes = {
  agent: PropTypes.object.isRequired,
}

export default Agent
